import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import InsightsIndex from "@/pages/InsightsIndex";
import InsightDetail from "@/pages/InsightDetail";
import Leadership from "@/pages/Leadership";
import ScrollToHash from "@/components/site/ScrollToHash";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToHash />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/leadership" element={<Leadership />} />
                    <Route path="/insights" element={<InsightsIndex />} />
                    <Route
                        path="/insights/:slug"
                        element={<InsightDetail />}
                    />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="bottom-center"
                toastOptions={{
                    style: {
                        background: "#1E1D1B",
                        color: "#F5F2EB",
                        border: "1px solid #2B4232",
                        borderRadius: 0,
                        fontFamily: "'Chivo', sans-serif",
                        fontSize: "13px",
                        letterSpacing: "0.02em",
                    },
                }}
            />
        </div>
    );
}

export default App;
